import { IconComponent } from 'design-system/types'
import * as React from 'react'

export const SortUp: IconComponent = ({ size = 24, ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 8 6"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path d="M7.717 3.797L4.715.793a.996.996 0 00-1.41 0L.293 3.787a1.01 1.01 0 000 1.422c.2.2.47.3.73.29h5.944c.27 0 .53-.08.74-.28a1.01 1.01 0 000-1.422h.01z" />
    </svg>
  )
}
